import { AddressSuggestionDto, ShapefileType } from '@agroone/entities'
import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { API_URL } from '../../../models/environment.token'
import { map, Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class GeolocationHttpService {
  private readonly _http = inject(HttpClient)

  private _apiUrl: string = inject(API_URL)

  public getShapefile(type: ShapefileType, ids: number[], boundaryIds?: number[]): Observable<string> {
    return this._http
      .post<{ base64: string }>(`${this._apiUrl}/geolocation/shapefile`, {
        ids,
        type,
        boundaryIds,
      })
      .pipe(map((res) => res.base64))
  }

  public searchAddress(query: string, country: string): Observable<AddressSuggestionDto[]> {
    return this._http.get<AddressSuggestionDto[]>(`${this._apiUrl}/geolocation/address/search`, {
      params: { q: query, country },
    })
  }
}
